import http from "../httpService";
import {getBaseUrl} from "../../config";


export const getAgentRequest = id => {
  return http.get(
    `${getBaseUrl()}/agent_request/${id}`
  );
};

export const getAgentRequestInfo = id => {
  return http.get(
    `${getBaseUrl()}/agent_request_info/${id}`
  );
};

export const getUserAgentRequest = () => {
  return http.get(
    `${getBaseUrl()}/user_agent_request`
  );
};

// TODO: check usage
export const getAgentRequests = () => {
  return http.get(
    `${getBaseUrl()}/agent_request`
  );
};

// TODO: check usage
export const updateAgentRequest = data => {


  return http.put(
    `${getBaseUrl()}/agent_request/${data.id}`,
    data
  );
};

export const updateAgentRequestPersonalInfo = data => {

  http.hasFile();

  return http.put(
    `${getBaseUrl()}/agent_request_personal_info/${data.id}`,
    data
  );
};

export const updateAgentRequestContactInfo = data => {


  return http.put(
    `${getBaseUrl()}/agent_request_contact_info/${data.id}`,
    data
  );
};

export const updateAgentRequestExpertInfo = data => {
  return http.put(
    `${getBaseUrl()}/agent_request_expert_info/${data.agent_request.id}`,
    data
  );
};

export const updateAgentRequestFile = data => {

  http.hasFile();
  return http.put(
    `${getBaseUrl()}/agent_request_file/${data.id}`,
    data
  );
};

export const submitAgentRequest = data => {

  http.hasFile();

  return http.post(
    `${getBaseUrl()}/agent_request`,
    data
  );
};
